module.exports = __webpack_public_path__ + "static/media/refurbishCarpetBlinds2 - Keep it simple post.2b41302d.jpg";